<script setup lang="ts">
import { computed } from 'vue';

import type { Agent } from '@/types';

const SHOW_AGENTS_COUNT = 4;

const { agents } = defineProps<{ agents: Agent[] }>();

const agentsCount = computed(() =>
  agents.length > SHOW_AGENTS_COUNT ? agents.length - (agents || []).length : 0,
);
</script>

<template>
  <div>
    <div :class="$style.agencyAgents">
      <div
        v-for="agent in agents.slice(0, SHOW_AGENTS_COUNT)"
        :key="agent.avatarUrl"
        :class="$style.agencyAgentAvatar"
      >
        <img :src="agent.avatarUrl" />
      </div>
      <div v-if="agentsCount" :class="$style.agencyAgentAvatarPlaceholder">+{{ agentsCount }}</div>
    </div>
  </div>
</template>

<style lang="scss" module>
@use '@/assets/variables' as *;

.agencyAgents {
  display: flex;
  padding-top: $space-200;

  @media (max-width: $viewport-sm-min) {
    padding-top: $space-150;
  }

  .agencyAgentAvatar {
    margin-left: -24px;

    &:first-of-type {
      margin-left: 0;
    }

    img {
      width: 64px;
      height: 64px;
      border: 2px solid $color-white;
      border-radius: 35px;
    }
  }

  .agencyAgentAvatarPlaceholder {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
    margin-left: -24px;
    color: $color-grey-90;
    background-color: $color-grey-30;
    border-radius: 30px;
  }
}
</style>
